import { useEffect, useState } from 'react';
var PREFIX = 'jove';
export function getStorageValue(key, defaultValue) {
  if (true) {
    var _localStorage;

    var saved = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(getKey(key));

    if (typeof saved === 'string') {
      try {
        return JSON.parse(saved);
      } catch (error) {
        return defaultValue;
      }
    }
  }

  return defaultValue;
}
export function setStorageValue(key, value) {
  var _localStorage2;

  (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem(getKey(key), JSON.stringify(value));
  return value;
}
export function useLocalStorage(key, defaultValue) {
  var _useState = useState(function () {
    return getStorageValue(key, defaultValue);
  }),
      value = _useState[0],
      setValue = _useState[1];

  useEffect(function () {
    setValue(getStorageValue(key, defaultValue));
  }, [key]);
  useEffect(function () {
    setStorageValue(key, value);
  }, [key, value]);
  return [value, setValue];
}
export function getKey(key) {
  return "".concat(PREFIX, "-").concat(key);
}